const StatisticalVideo = () =>
  import('@/views/main/fubo/statisticalVideo/StatisticalVideo.vue')
export default {
  path: '/main/fubo/statisticalVideo',
  name: 'FuboStatisticalVideo',
  component: StatisticalVideo,
  children: []
}
